import { type ComponentProps } from 'react';
import { CheckXIcon } from '@zep-us/zus/icons';
import { OxIcon } from '@/icons';
import { useIsOXLocale } from '@/shared/hooks';
type LocalizedOxTypeIconProps = ComponentProps<typeof OxIcon>;
export const LocalizedOxTypeIcon = (props: LocalizedOxTypeIconProps) => {
  const isOXLocale = useIsOXLocale();
  const Icon = isOXLocale ? OxIcon : CheckXIcon;
  return <Icon {...props} data-sentry-element="Icon" data-sentry-component="LocalizedOxTypeIcon" data-sentry-source-file="LocalizedOxTypeIcon.tsx" />;
};